"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledDropdownMenu = _interopRequireDefault(require("./styled-dropdown-menu"));

var _actionElement = _interopRequireDefault(require("./action-element"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

/*

Example usage:

- Just use the compound component in your <Navigation />

<Navigation.HelpButton className='pl-3'>
  <StyledMenuItem
    onClick={SupportCenterHelper.goToSupportCenter}
    dataElementLocation={DataElementLocations.POP_UP}
    dataElementLabel='smartBlog.nav.supportCenter'
    dataElementId='support-center--help-option'
  >
    <ListItemIcon>
      <Icon icon='help' />
    </ListItemIcon>
    <Typography variant='body2'>
      <Text message='smartBlog.nav.supportCenter' />
    </Typography>
  </StyledMenuItem>
</Navigation.HelpButton>

*/
var helpButton = /*#__PURE__*/_react["default"].createElement(_actionElement["default"], {
  dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
  dataElementLabel: "header-action--navigation-help",
  dataElementId: "help-button-navigation"
});

var HelpButton = function HelpButton(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_styledDropdownMenu["default"], {
    actionElement: helpButton,
    className: className
  }, children);
};

HelpButton.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element]),
  className: _propTypes["default"].string
};
var _default = HelpButton;
exports["default"] = _default;